module.exports = __webpack_public_path__ + "img/c3f0b3da77aa2d88f3ae64b21794675c.png";